import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)">


<path d="M9220 10474 c-112 -48 -142 -181 -63 -275 39 -46 74 -59 190 -70 725
-68 1328 -583 1509 -1287 29 -113 46 -144 94 -171 93 -52 202 -6 230 97 10 38
8 57 -15 150 -207 829 -881 1432 -1742 1556 -136 19 -158 19 -203 0z"/>
<path d="M9221 9873 c-57 -30 -76 -65 -76 -138 0 -71 17 -103 75 -142 24 -17
48 -23 89 -23 181 -1 428 -89 611 -218 93 -65 225 -203 294 -306 73 -110 117
-205 150 -321 19 -69 32 -96 55 -117 100 -90 252 -27 253 105 1 56 -50 207
-116 342 -199 406 -585 707 -1035 805 -50 11 -131 23 -179 26 -72 4 -93 2
-121 -13z"/>
<path d="M4580 9689 c-388 -37 -797 -207 -1105 -459 -588 -481 -840 -1229
-623 -1850 185 -530 684 -916 1285 -995 96 -13 311 -15 1370 -15 l1256 0 135
71 c359 189 706 424 946 641 75 69 226 233 226 247 0 15 -238 82 -405 115
-257 50 -221 49 -1670 56 l-1360 6 -79 22 c-273 76 -406 228 -406 463 0 255
167 438 440 483 19 3 510 6 1090 6 580 1 1109 5 1175 10 212 16 361 57 550
150 273 135 426 284 805 780 74 96 149 193 167 214 18 22 33 46 33 53 0 11
-328 13 -1872 12 -1030 -1 -1911 -5 -1958 -10z m-57 -26 c-7 -2 -21 -2 -30 0
-10 3 -4 5 12 5 17 0 24 -2 18 -5z m-53 -7 c0 -2 -13 -6 -29 -8 -17 -2 -28 -1
-25 4 5 8 54 12 54 4z m-73 -12 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17
-2 13 -5z m-40 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-40 -10 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M9292 9341 c-85 -40 -105 -156 -38 -227 26 -29 43 -36 108 -48 149
-28 271 -92 377 -197 75 -75 123 -149 158 -247 13 -37 32 -75 41 -86 63 -69
175 -57 230 24 32 47 26 100 -21 208 -53 125 -94 186 -184 282 -126 133 -251
213 -421 270 -121 40 -195 46 -250 21z"/>
<path d="M8953 9089 c-16 -35 -103 -230 -193 -434 -90 -203 -171 -379 -181
-389 -20 -22 21 -19 -863 -44 -170 -4 -271 -11 -273 -17 -2 -6 95 -63 214
-128 120 -64 313 -168 428 -231 116 -62 228 -129 249 -149 l39 -37 -6 -70 c-7
-85 -50 -181 -129 -285 -256 -339 -740 -703 -1338 -1008 -85 -43 -156 -83
-158 -87 -2 -5 -10 -6 -19 -3 -12 5 -14 3 -8 -7 5 -8 4 -11 -3 -6 -6 3 -75
-22 -154 -57 -79 -35 -220 -95 -315 -133 -95 -38 -168 -70 -163 -72 5 -2 18 2
29 8 25 13 26 7 6 -23 -8 -13 -13 -33 -10 -45 3 -16 -4 -27 -23 -39 -41 -25
-82 -65 -82 -80 0 -7 -7 -13 -16 -13 -22 0 -45 -26 -38 -44 3 -8 2 -21 -2 -28
-6 -9 -10 -6 -15 12 -5 19 -7 13 -8 -23 -1 -29 -5 -46 -11 -42 -6 4 -10 -6
-10 -23 0 -38 -17 -52 -61 -50 -47 2 -84 -19 -69 -37 7 -8 9 -19 5 -25 -12
-20 26 -52 55 -46 14 3 5 -4 -20 -15 -48 -23 -127 -31 -137 -15 -4 5 -1 12 5
14 7 2 12 11 11 20 0 11 -2 12 -6 5 -2 -7 -13 -13 -24 -13 -13 0 -17 -5 -13
-17 5 -15 4 -16 -5 -3 -6 8 -11 25 -11 38 0 17 -6 22 -27 22 -16 1 -39 7 -52
14 -14 8 -31 12 -38 9 -7 -3 -13 0 -13 6 0 6 -17 19 -37 29 -21 9 -43 23 -49
31 -10 13 -14 12 -29 -2 -13 -14 -20 -15 -31 -6 -8 6 -11 15 -8 20 3 5 1 9 -5
9 -5 0 -23 11 -39 25 -16 13 -32 22 -36 18 -3 -3 -6 -1 -6 5 0 7 -7 12 -16 12
-8 0 -12 -5 -9 -10 4 -6 -3 -9 -17 -6 -13 2 -45 -3 -71 -11 -27 -8 -51 -12
-53 -10 -3 2 48 19 111 37 63 18 114 35 111 37 -2 2 -93 -21 -203 -51 -669
-183 -1347 -298 -1763 -299 -263 0 -407 34 -474 114 -137 162 67 441 614 838
63 46 120 88 125 93 17 16 -331 -160 -465 -235 -685 -384 -1082 -741 -1141
-1026 -19 -95 18 -196 95 -254 315 -240 1196 -196 2371 118 398 107 822 243
1286 414 164 60 278 107 229 95 -14 -4 -32 -8 -40 -11 -8 -2 -1 3 15 11 17 8
38 13 47 10 35 -10 595 230 983 421 474 234 898 488 1385 829 241 169 384 276
844 634 337 263 983 751 1110 839 85 60 121 57 -549 44 -220 -5 -409 -5 -419
-1 -14 5 -42 63 -96 201 -144 364 -272 674 -280 683 -5 5 -21 -19 -37 -55z
m-2468 -3009 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z m-558 -552 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-307
-177 c-8 -5 -26 -11 -40 -15 -21 -5 -20 -3 5 9 32 15 60 20 35 6z"/>
<path d="M9644 7518 l-19 -21 30 18 c41 26 40 25 23 25 -8 0 -23 -10 -34 -22z"/>
<path d="M9540 7439 c-77 -62 -126 -108 -85 -79 11 8 30 23 42 33 12 11 27 16
34 12 8 -6 10 -4 4 5 -6 9 -4 11 5 5 9 -6 11 -4 5 5 -6 9 -4 11 4 6 9 -6 8
-13 -5 -27 -9 -10 -19 -18 -23 -17 -20 2 -31 -3 -26 -12 4 -6 3 -9 -2 -8 -4 1
-18 -3 -29 -10 -12 -6 -24 -9 -27 -5 -9 8 -38 -17 -32 -27 3 -5 0 -12 -6 -16
-8 -4 -9 -3 -5 4 12 20 -5 13 -46 -19 -21 -17 -37 -34 -34 -37 8 -7 -14 -32
-27 -32 -6 0 -2 7 9 16 14 12 12 12 -11 -1 -60 -36 -303 -230 -297 -239 3 -5
1 -6 -5 -3 -9 6 -328 -228 -328 -241 0 -4 -8 -18 -18 -32 -9 -13 -17 -21 -17
-17 0 4 -9 3 -20 -3 -11 -6 -17 -16 -14 -22 4 -7 3 -8 -4 -4 -18 11 -16 13 28
42 22 15 38 29 36 31 -3 3 -22 -8 -43 -23 -21 -16 -40 -29 -42 -30 -1 -2 24
-35 57 -74 68 -80 121 -175 148 -265 14 -46 18 -91 18 -190 -1 -114 -4 -140
-28 -210 -68 -201 -220 -369 -398 -442 -148 -60 -77 -57 -1148 -63 l-985 -5
-65 -28 c-59 -26 -418 -162 -700 -267 -199 -73 -875 -296 -1110 -365 -124 -37
-315 -89 -425 -116 -376 -92 -346 -82 -453 -159 -53 -39 -152 -110 -219 -158
-68 -48 -123 -90 -123 -93 0 -4 37 -9 83 -11 106 -6 942 10 982 18 17 4 966
10 2110 14 2240 8 2112 5 2322 59 192 50 410 145 576 254 392 256 685 641 830
1092 155 482 118 993 -106 1450 -61 125 -187 332 -187 309 0 -14 -142 -14
-152 0 -4 6 2 21 14 33 34 36 19 27 -62 -38z m35 1 c-3 -5 -11 -10 -16 -10 -6
0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z"/>
<path d="M5835 5850 c-13 -6 -15 -9 -5 -9 8 0 22 4 30 9 18 12 2 12 -25 0z"/>
<path d="M5729 5473 c-1 -5 -1 -11 0 -15 0 -5 -6 -8 -14 -8 -8 0 -15 -6 -15
-14 0 -15 51 -26 81 -19 17 5 17 6 -2 26 -10 11 -19 24 -19 29 0 10 -30 11
-31 1z"/>
<path d="M5359 3831 c-69 -22 -99 -61 -99 -131 0 -89 53 -135 155 -134 103 1
159 48 159 135 0 99 -105 163 -215 130z"/>
<path d="M1786 3814 c-107 -19 -215 -72 -259 -127 -61 -75 -80 -123 -85 -217
-12 -234 99 -330 448 -389 186 -32 247 -49 270 -79 27 -34 25 -77 -4 -107 -39
-38 -95 -48 -251 -42 -145 5 -251 30 -349 79 -38 19 -39 19 -56 1 -9 -10 -39
-59 -65 -109 -47 -89 -48 -93 -32 -117 57 -88 390 -152 656 -128 171 16 254
46 337 123 67 61 97 134 102 244 7 154 -42 246 -165 311 -77 41 -139 58 -313
88 -178 30 -216 41 -241 66 -27 27 -25 80 4 106 40 37 91 46 226 40 120 -5
198 -21 289 -58 22 -9 37 -10 48 -4 20 13 95 185 92 210 -13 87 -406 153 -652
109z"/>
<path d="M4872 3798 c-9 -9 -12 -157 -12 -605 l0 -593 140 0 140 0 0 593 c0
448 -3 596 -12 605 -8 8 -51 12 -128 12 -77 0 -120 -4 -128 -12z"/>
<path d="M6676 3794 c-14 -14 -16 -82 -16 -605 l0 -590 138 3 137 3 5 140 c4
109 9 145 22 164 9 13 21 22 28 19 6 -2 66 -75 133 -163 l123 -160 169 0 c123
0 170 3 170 12 0 6 -76 107 -170 224 -93 117 -174 220 -179 230 -6 13 26 56
155 204 90 102 165 193 167 201 3 12 -22 14 -157 14 -189 0 -155 19 -327 -185
-64 -77 -121 -141 -126 -143 -4 -2 -8 138 -8 310 0 231 -3 317 -12 326 -19 19
-232 16 -252 -4z"/>
<path d="M7657 3783 c-16 -18 -17 -63 -17 -590 0 -485 2 -572 14 -583 11 -8
93 -11 323 -8 305 4 309 4 383 31 104 38 173 82 235 150 101 111 145 238 145
422 0 122 -13 182 -59 281 -41 88 -151 197 -242 241 -127 61 -157 65 -474 70
-276 5 -291 4 -308 -14z m571 -278 c117 -35 189 -130 199 -266 13 -171 -65
-308 -198 -348 -20 -6 -93 -11 -163 -11 l-126 0 0 320 0 320 118 0 c77 0 136
-5 170 -15z"/>
<path d="M9809 3719 c-7 -13 -10 -57 -8 -113 l4 -91 -60 -5 -60 -5 -3 -82 c-1
-45 1 -97 6 -115 8 -32 10 -33 68 -38 l59 -5 6 -215 c5 -193 7 -221 28 -274
27 -68 84 -130 145 -156 89 -40 271 -50 350 -20 26 9 26 10 26 117 0 60 -4
113 -8 119 -4 8 -37 11 -89 10 -69 -1 -86 2 -110 20 -48 36 -53 56 -53 232 l0
162 114 0 c63 0 121 3 130 6 13 5 16 25 16 114 0 76 -4 111 -12 117 -7 4 -69
10 -138 13 l-125 5 -3 99 c-1 55 -8 106 -14 113 -7 9 -45 13 -134 13 -116 0
-124 -1 -135 -21z"/>
<path d="M2760 3693 c-46 -2 -90 -9 -97 -15 -9 -7 -13 -39 -13 -99 l0 -89 -51
0 c-85 0 -89 -5 -89 -119 0 -68 4 -102 13 -109 7 -6 37 -12 67 -14 l55 -3 6
-215 c5 -214 10 -249 48 -310 44 -73 111 -113 219 -131 84 -14 215 -4 237 18
18 18 22 212 4 230 -6 6 -35 9 -73 6 -70 -6 -116 11 -138 50 -9 15 -13 72 -13
187 l0 165 109 3 c61 1 116 8 123 14 18 14 18 203 1 215 -7 4 -62 10 -123 13
l-110 5 -3 93 c-3 89 -4 93 -28 102 -14 6 -33 9 -42 8 -9 -1 -55 -4 -102 -5z"/>
<path d="M10652 3510 c-80 -21 -149 -55 -165 -81 -8 -12 -2 -38 23 -98 19 -45
40 -86 46 -92 9 -7 24 -4 51 9 131 67 314 70 374 6 13 -14 23 -41 27 -70 l5
-47 -29 6 c-108 23 -207 29 -280 18 -198 -29 -294 -128 -294 -301 0 -55 6 -78
31 -128 51 -103 147 -152 294 -152 99 0 167 19 233 65 l51 35 3 -38 3 -37 119
-3 c81 -2 123 1 133 9 12 11 14 64 11 343 -3 321 -4 333 -26 381 -44 95 -129
160 -240 184 -86 18 -285 13 -370 -9z m321 -541 c36 -10 37 -11 37 -58 0 -91
-70 -137 -199 -129 -88 5 -121 30 -121 90 0 82 37 107 160 108 47 0 102 -5
123 -11z"/>
<path d="M3525 3511 c-112 -19 -230 -66 -242 -97 -7 -18 57 -175 74 -181 7 -3
43 7 80 22 83 33 215 44 278 23 48 -16 85 -66 85 -116 0 -31 -2 -34 -22 -28
-13 3 -64 11 -115 18 -146 19 -280 -10 -371 -79 -107 -82 -115 -305 -15 -408
56 -57 112 -78 224 -83 116 -5 187 12 253 63 l45 34 3 -37 3 -37 124 -3 c82
-2 128 1 137 9 21 18 20 581 -1 664 -28 108 -105 186 -218 220 -60 19 -249 28
-322 16z m218 -542 l57 -12 0 -49 c0 -43 -5 -55 -33 -83 -62 -62 -204 -70
-259 -14 -49 49 -32 125 36 155 38 16 124 18 199 3z"/>
<path d="M6124 3507 c-57 -15 -108 -44 -143 -81 -32 -34 -36 -33 -39 11 -2 20
-5 40 -8 45 -8 13 -238 10 -252 -4 -9 -9 -12 -122 -12 -445 l0 -433 139 0 140
0 3 284 c3 271 4 286 24 313 54 72 151 96 221 53 57 -34 58 -40 63 -355 l5
-290 135 0 135 0 3 332 c2 312 1 335 -18 386 -44 117 -141 185 -274 193 -39 2
-94 -2 -122 -9z"/>
<path d="M9085 3514 c-103 -22 -201 -60 -224 -87 -12 -15 -9 -29 24 -107 31
-74 42 -90 59 -90 12 0 26 4 32 9 24 24 141 52 218 53 131 1 186 -37 186 -128
0 -28 -3 -35 -15 -30 -45 17 -158 28 -239 23 -165 -10 -255 -56 -311 -157 -25
-47 -29 -66 -30 -130 0 -97 22 -156 80 -209 63 -58 104 -73 221 -78 121 -7
189 10 257 62 l46 35 3 -38 3 -37 119 -3 c78 -2 123 1 132 9 22 18 20 601 -2
681 -30 106 -128 190 -252 217 -50 10 -263 14 -307 5z m245 -545 l50 -11 0
-52 c0 -44 -4 -56 -27 -78 -39 -37 -74 -48 -151 -48 -86 0 -128 23 -138 75
-14 79 40 125 148 125 37 0 90 -5 118 -11z"/>
<path d="M4584 3486 c-27 -13 -67 -43 -87 -66 l-37 -44 0 32 c0 17 -4 42 -10
56 -9 26 -10 26 -123 26 -98 0 -116 -3 -130 -18 -15 -17 -17 -62 -17 -446 l0
-427 143 3 142 3 5 266 5 266 27 35 c39 52 89 72 180 74 42 1 81 5 87 8 16 10
15 228 -1 244 -21 21 -127 14 -184 -12z"/>
<path d="M5286 3474 c-14 -14 -16 -64 -14 -442 l3 -427 140 0 140 0 3 427 c2
378 0 428 -14 442 -12 13 -39 16 -129 16 -90 0 -117 -3 -129 -16z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
